import { useState, type ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'

interface CollapsibleSectionProps {
  title: string
  defaultOpen?: boolean
  children: ReactNode
  badge?: ReactNode
}

export function CollapsibleSection({
  title,
  defaultOpen = true,
  children,
  badge,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div
      className="rounded-lg border overflow-hidden border-fn-border bg-fn-card"
    >
      <button
        type="button"
        className="w-full flex items-center justify-between px-4 py-3 text-left transition-colors hover:bg-fn-hover"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-fn-text">
            {title}
          </span>
          {badge}
        </div>
        <ChevronDown
          className="w-4 h-4 transition-transform duration-200 text-fn-text-muted"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </button>
      {isOpen && (
        <div className="px-4 pb-4 pt-1 animate-slide-down">
          {children}
        </div>
      )}
    </div>
  )
}
